import { Link } from "react-router-dom";
import { DataTable } from "../../components/DataTable";
import { useIntl } from "../../lib/i18n";
import { useFetch } from "../../lib/useFetch";

type Row = {
  id: string;
  matterId?: string | null;
  state: string;
  templateName?: string | null;
  updatedAt: string;
};

export default function DraftsPage() {
  const { t } = useIntl();
  const { data, loading, error } = useFetch<{ drafts: Row[] }>("/api/v1/tenant/drafts");
  return (
    <div>
      <h1 className="text-2xl font-semibold text-brand-900">{t("drafts.title")}</h1>
      <DataTable
        rows={data?.drafts ?? null}
        loading={loading}
        error={error}
        empty={t("drafts.empty")}
        columns={[
          {
            header: t("drafts.col.template"),
            render: (r) => (
              <Link className="text-brand-700 hover:underline" to={`/admin/drafts/${r.id}`}>
                {r.templateName ?? "—"}
              </Link>
            ),
          },
          { header: t("drafts.col.matter"), render: (r) => r.matterId ?? "—" },
          { header: t("drafts.col.state"), render: (r) => r.state },
          {
            header: t("drafts.col.updated"),
            render: (r) => new Date(r.updatedAt).toLocaleString(),
          },
        ]}
      />
    </div>
  );
}
